import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=39806622&scoped=true"
import script from "./customPage.vue?vue&type=script&lang=js"
export * from "./customPage.vue?vue&type=script&lang=js"
import style0 from "./customPage.vue?vue&type=style&index=0&id=39806622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39806622",
  null
  
)

export default component.exports